
  (function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-brum-pdp]');
    if (!root) return;

    var mapOverlay = root.querySelector('.map-popup-overlay');
    var mapBtn     = root.querySelector('.open-map-btn');
    if (mapOverlay) document.body.appendChild(mapOverlay);

    if (mapBtn && mapOverlay) {
      var closeBtn = mapOverlay.querySelector('.close-map-btn');

      mapBtn.addEventListener('click', function () {
        mapOverlay.classList.add('active');
        document.body.classList.add('no-scroll');
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          mapOverlay.classList.remove('active');
          document.body.classList.remove('no-scroll');
        });
      }
      mapOverlay.addEventListener('click', function (e) {
        if (e.target === mapOverlay) {
          mapOverlay.classList.remove('active');
          document.body.classList.remove('no-scroll');
        }
      });
    }
    // Move wishlist heart into the main image viewer (so it sits on the
      // image, not on the thumbnails strip below it).
      var wishlistBtn = root.querySelector('.brum-pdp__wishlist');
      var galleryViewer = root.querySelector('.media-gallery__viewer');
      if (wishlistBtn && galleryViewer) {
        galleryViewer.appendChild(wishlistBtn);
      }

    var toolbar = root.querySelector('products-toolbar') || root.querySelector('.products-toolbar');
if (toolbar) {
  var ticking = false;
  var THRESHOLD = 120;
  var onScrollToolbar = function () {
    if (window.scrollY > THRESHOLD) {
      toolbar.classList.add('is-visible');
    } else {
      toolbar.classList.remove('is-visible');
    }
    ticking = false;
  };
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScrollToolbar);
      ticking = true;
    }
  }, { passive: true });
}

// ── Bottom bar: Contact / Share expand/collapse
      var bottomBar = root.querySelector('[data-brum-bottombar]');
      if (bottomBar) {
        var bbTriggers = bottomBar.querySelectorAll('[data-bbg-trigger]');
        bbTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            var group = trigger.closest('.brum-pdp__bbg');
            var isExpanded = group.classList.toggle('is-expanded');
            trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
            if (isExpanded) {
              bottomBar.querySelectorAll('.brum-pdp__bbg.is-expanded').forEach(function (other) {
                if (other !== group) {
                  other.classList.remove('is-expanded');
                  var otherTrigger = other.querySelector('[data-bbg-trigger]');
                  if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
                }
              });
            }
          });
        });
        document.addEventListener('click', function (e) {
          if (!bottomBar.contains(e.target)) {
            bottomBar.querySelectorAll('.brum-pdp__bbg.is-expanded').forEach(function (group) {
              group.classList.remove('is-expanded');
              var t = group.querySelector('[data-bbg-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
          }
        });
      }

      // ── Copy-link feedback: show "Link copied!" inside the button briefly
      var copyBtns = root.querySelectorAll('.copy-product-link');
      copyBtns.forEach(function (btn) {
        var label = btn.querySelector('span');
        if (!label) return;
        var resetTimer = null;
        btn.addEventListener('click', function () {
          var link = btn.dataset.link;
          if (link && navigator.clipboard) {
            navigator.clipboard.writeText(link).catch(function () { /* no-op */ });
          }
          var original = label.getAttribute('data-original') || label.textContent;
          label.setAttribute('data-original', original);
          label.textContent = 'Link copied!';
          clearTimeout(resetTimer);
          resetTimer = setTimeout(function () {
            label.textContent = original;
          }, 1500);
        });
      });

      // ── Share buttons (Facebook / WhatsApp) — open native share dialog
      var shareBtns = root.querySelectorAll('.share-btn');
      shareBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var platform = btn.dataset.platform;
          var url = btn.dataset.url;
          if (!url) return;
          var shareUrl = '';
          if (platform === 'facebook') {
            shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
          } else if (platform === 'whatsapp') {
            shareUrl = 'https://wa.me/?text=' + encodeURIComponent(url);
          }
          if (shareUrl) {
            window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=700');
          }
        });
      });
      

      // ── Analytics view tracking ─────────────────────────────────────────
      var vehicleId = root.dataset.vehicleId;
      var customerId = root.dataset.customerId;
      var token = root.dataset.token;
      if (vehicleId) {
        try {
          fetch('https://api.vbay.eqserver.net/api/analytics/view', {
            method: 'POST',
            headers: { 'Authorization': token, 'Content-Type': 'application/json' },
            body: JSON.stringify({ vehicle_id: vehicleId, user_id: customerId })
          }).catch(function (e) { console.warn('[Brum PDP] analytics failed', e); });
        } catch (e) { /* no-op */ }
      }


      // ── Lightbox counter injection (template stage) ─────────────────────
      var lbTemplate = document.querySelector('.js-media-zoom-template');
      if (lbTemplate) {
        var lbControls = lbTemplate.content.querySelector('.gallery-zoom__controls');
        var lbNextBtn = lbTemplate.content.querySelector('.gallery-zoom__next');
        if (lbControls && lbNextBtn && !lbTemplate.content.querySelector('.media-ctrl__counter')) {
          var lbTotal = lbTemplate.content.querySelectorAll('.gallery-zoom__thumb').length;
          var lbCounter = document.createElement('div');
          lbCounter.className = 'media-ctrl__counter';
          lbCounter.innerHTML =
            '<span class="media-ctrl__current-item">1</span>' +
            ' / ' +
            '<span class="media-ctrl__total-items">' + lbTotal + '</span>';
          lbControls.insertBefore(lbCounter, lbNextBtn);
        }
      }

      // ── Lightbox observer: counter update + swipe wiring ───────────────
      var lightboxBodyObserver = new MutationObserver(function () {
        var modal = document.body.querySelector('.gallery-zoom-modal');
        if (!modal || modal.dataset.brumCounterInit) return;
        modal.dataset.brumCounterInit = '1';
        var modalThumbs = modal.querySelectorAll('.gallery-zoom__thumb');
        var currentEl = modal.querySelector('.media-ctrl__current-item');

        // Fallback: inject counter into live modal if template stage missed it
        if (!currentEl) {
          var ctlEl = modal.querySelector('.gallery-zoom__controls');
          var nxtEl = modal.querySelector('.gallery-zoom__next');
          if (ctlEl && nxtEl) {
            var cntEl = document.createElement('div');
            cntEl.className = 'media-ctrl__counter';
            cntEl.innerHTML =
              '<span class="media-ctrl__current-item">1</span>' +
              ' / ' +
              '<span class="media-ctrl__total-items">' + modalThumbs.length + '</span>';
            ctlEl.insertBefore(cntEl, nxtEl);
            currentEl = modal.querySelector('.media-ctrl__current-item');
          }
        }

        if (modalThumbs.length && currentEl) {
          var lastValue = currentEl.textContent;
          var flipTimer = null;
          var updateCounter = function () {
            for (var i = 0; i < modalThumbs.length; i++) {
              if (modalThumbs[i].classList.contains('gallery-zoom__thumb--active')) {
                var newVal = String(i + 1);
                if (newVal !== lastValue) {
                  currentEl.classList.add('is-flipping');
                  clearTimeout(flipTimer);
                  flipTimer = setTimeout(function () {
                    currentEl.textContent = newVal;
                    currentEl.classList.remove('is-flipping');
                  }, 140);
                  lastValue = newVal;
                  try {
                    modalThumbs[i].scrollIntoView({
                      behavior: 'smooth',
                      inline: 'center',
                      block: 'nearest'
                    });
                  } catch (e) { /* older browsers */ }
                }
                return;
              }
            }
          };
          var thumbObs = new MutationObserver(updateCounter);
          modalThumbs.forEach(function (t) {
            thumbObs.observe(t, { attributes: true, attributeFilter: ['class'] });
          });
          updateCounter();
        }

        var zoomContainer = modal.querySelector('.gallery-zoom__zoom-container');
        var prevBtn = modal.querySelector('.gallery-zoom__prev');
        var nextBtn = modal.querySelector('.gallery-zoom__next');
        if (zoomContainer && prevBtn && nextBtn) {
          var touchStartX = 0, touchStartY = 0, touchStartT = 0;

          var isZoomedIn = function () {
            var gz = modal.querySelector('gallery-zoom');
            var img = zoomContainer.querySelector('.gallery-zoom__zoom-image');
            if (!gz || !img || !gz.currentTransform || !img.naturalWidth || !img.naturalHeight) return false;
            var fitScale = Math.min(
              gz.clientWidth / img.naturalWidth,
              gz.clientHeight / img.naturalHeight
            );
            return gz.currentTransform.zoom > fitScale * 1.05;
          };

          zoomContainer.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1 || isZoomedIn()) {
              touchStartT = 0;
              return;
            }
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchStartT = Date.now();
          }, { passive: true });

          zoomContainer.addEventListener('touchmove', function (e) {
            // Second finger OR theme started zooming mid-gesture → cancel.
            if (e.touches.length > 1 || isZoomedIn()) touchStartT = 0;
          }, { passive: true });

          zoomContainer.addEventListener('touchend', function (e) {
            if (!touchStartT || isZoomedIn()) {
              touchStartT = 0;
              return;
            }
            var dx = e.changedTouches[0].clientX - touchStartX;
            var dy = e.changedTouches[0].clientY - touchStartY;
            var dt = Date.now() - touchStartT;
            touchStartT = 0;
            if (Math.abs(dx) < 60 || Math.abs(dy) > 40 || dt > 500) return;
            if (dx < 0 && !nextBtn.disabled) nextBtn.click();
            else if (dx > 0 && !prevBtn.disabled) prevBtn.click();
          }, { passive: true });
          zoomContainer.addEventListener('click', function (e) {
            if (isZoomedIn()) return; // let zoom-out work anywhere
            if (e.target && e.target.closest && e.target.closest('.gallery-zoom__zoom-image')) return;
            e.stopImmediatePropagation();
          }, true);

        if (zoomContainer) {
          var setZoomedClass = function () {
            modal.classList.toggle('brum-zoomed', isZoomedIn());
          };
          var zoomStateObs = new MutationObserver(setZoomedClass);
          zoomStateObs.observe(zoomContainer, {
            attributes: true,
            attributeFilter: ['style'],
            subtree: true
          });
          setZoomedClass();
        }
        }
      });
      lightboxBodyObserver.observe(document.body, { childList: true });


      (function wireLightboxFullscreen() {
        var docEl = document.documentElement;
        var fsRequest = docEl.requestFullscreen
          || docEl.webkitRequestFullscreen
          || docEl.msRequestFullscreen;
        var fsExit = function () {
          var ex = document.exitFullscreen
            || document.webkitExitFullscreen
            || document.msExitFullscreen;
          if (ex) ex.call(document);
        };
        var fsElement = function () {
          return document.fullscreenElement
            || document.webkitFullscreenElement
            || document.msFullscreenElement;
        };
        if (!fsRequest) return; // browser doesn't support FS API at all


        document.addEventListener('click', function (e) {
          if (!e.target.closest) return;
          // Only fire on a direct click on the image's zoom-link
          var trigger = e.target.closest('.js-zoom-link');
          if (!trigger) return;
          if (fsElement()) return; // already in fullscreen

          var requestModalFs = function (modal) {
            var mReq = modal.requestFullscreen
              || modal.webkitRequestFullscreen
              || modal.msRequestFullscreen;
            if (!mReq) return false;
            try {
              var p = mReq.call(modal);
              if (p && p.catch) p.catch(function () { /* iOS or denied */ });
              return true;
            } catch (err) { return false; }
          };

          // If the modal somehow already exists (rare), fullscreen it now
          var existingModal = document.querySelector('.gallery-zoom-modal');
          if (existingModal) {
            requestModalFs(existingModal);
            return;
          }

          // Otherwise wait briefly for the theme to inject it
          var modalObs = new MutationObserver(function (mutations, obs) {
            var modal = document.querySelector('.gallery-zoom-modal');
            if (!modal) return;
            obs.disconnect();
            if (giveUpTimer) clearTimeout(giveUpTimer);
            requestModalFs(modal);
          });
          modalObs.observe(document.body, { childList: true, subtree: true });
          // Safety: give up after 3 seconds so the observer doesn't linger
          var giveUpTimer = setTimeout(function () { modalObs.disconnect(); }, 3000);
        }, true);


        document.addEventListener('click', function (e) {
          if (!e.target.closest) return;
          var closeBtn = e.target.closest('.gallery-zoom__close');
          if (!closeBtn) return;
          if (!fsElement()) return; // not in our FS — let theme handle normally
          // Intercept: stop the theme close handler, exit FS first
          e.stopImmediatePropagation();
          e.preventDefault();
          // Mark this close button so the FS-exit handler below knows to
          // dispatch a fresh click (not just call .click() which would loop)
          closeBtn.dataset.brumFsCloseQueued = '1';
          fsExit();
        }, true);

        var onFsChange = function () {
          if (fsElement()) return; // entered fullscreen — nothing to do
          var modal = document.querySelector('.gallery-zoom-modal');
          if (modal && document.body.contains(modal)) {
            var closeBtn = modal.querySelector('.gallery-zoom__close');
            if (closeBtn) {
              if (closeBtn.dataset.brumFsCloseQueued) {
                delete closeBtn.dataset.brumFsCloseQueued;
              }
              closeBtn.click();
            }
          }
        };
        document.addEventListener('fullscreenchange', onFsChange);
        document.addEventListener('webkitfullscreenchange', onFsChange);

        new MutationObserver(function () {
          if (!fsElement()) return;
          if (!document.querySelector('.gallery-zoom-modal')) fsExit();
        }).observe(document.body, { childList: true });

        (function watchCachedModalReopen() {
          var lastUserClick = 0;
          document.addEventListener('click', function (e) {
            if (e.isTrusted) lastUserClick = Date.now();
          }, true);

          var tryFs = function (modal) {
            if (fsElement()) return;
            if (Date.now() - lastUserClick > 1500) return;
            var req = modal.requestFullscreen
              || modal.webkitRequestFullscreen
              || modal.msRequestFullscreen;
            if (!req) return;
            try {
              var p = req.call(modal);
              if (p && p.catch) p.catch(function () {});
            } catch (_) {}
          };

          var installModalObserver = function (modal) {
            new MutationObserver(function () {
              if (modal.hasAttribute('open')) tryFs(modal);
            }).observe(modal, { attributes: true, attributeFilter: ['open'] });
          };

          var existing = document.querySelector('.gallery-zoom-modal');
          if (existing) installModalObserver(existing);
          else {
            var bodyObs = new MutationObserver(function (muts) {
              for (var i = 0; i < muts.length; i++) {
                var added = muts[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                  var n = added[j];
                  if (n.nodeType === 1 && n.matches && n.matches('.gallery-zoom-modal')) {
                    installModalObserver(n);
                    bodyObs.disconnect();
                    return;
                  }
                }
              }
            });
            bodyObs.observe(document.body, { childList: true, subtree: true });
          }
        })();
      })();
    });

    // Expose token + customer for custom.js handlers
    window.globalToken = document.querySelector('[data-brum-pdp]')
      ? document.querySelector('[data-brum-pdp]').dataset.token : '';
    window.ShopCustomer = window.ShopCustomer || {
      email: document.querySelector('[data-brum-pdp]')
        ? document.querySelector('[data-brum-pdp]').dataset.customerEmail : '',
      id: document.querySelector('[data-brum-pdp]')
        ? document.querySelector('[data-brum-pdp]').dataset.customerId : ''
    };
  })();
